export default __webpack_public_path__ + "static/media/material-symbols_call.f1260979.svg";